import { useRef } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';
import { ScholarshipCard as CardProps } from '@common-types';

import { SwiperSlide } from 'swiper/react';
import { Swiper } from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { NavigationOptions } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/pagination';

import ScholarshipCard from '@components/ScholarshipCard';
import ActionButton from '@components/ActionButton';
import { ROUTES } from '@constants/ROUTES';
import { PAGE_TABS_DATA } from '@constants/scholarships';

import ChevronLeftIcon from '@images/chevron-left.svg?react';
import ChevronRightIcon from '@images/chevron-right.svg?react';

import {
  sxStyles,
  StyledSliderHeader,
  StyledSwiper,
  StyledNavigationButtonsWrap,
  StyledNavigationLink,
} from './RelatedScholarships.styles';

const SWIPER_DATA = {
  PAGINATION: {
    clickable: true,
  },
  BREAKPOINTS: {
    1180: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 1,
    },
  },
};

interface CollegesNearbyProps {
  scholarships: CardProps[];
}

export const RelatedScholarships = (props: CollegesNearbyProps) => {
  const { scholarships } = props;

  const navigationPrevRef = useRef<HTMLDivElement>(null);
  const navigationNextRef = useRef<HTMLDivElement>(null);

  const handleBeforeInit = (swiper: Swiper) => {
    // eslint-disable-next-line no-param-reassign
    swiper.params.navigation = {
      ...(swiper.params.navigation as NavigationOptions),
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    };
  };

  if (!scholarships.length) return null;

  return (
    <CoreBox sx={sxStyles.cardSlider}>
      <StyledSliderHeader>
        <CoreTypography sx={sxStyles.sliderTitle} variant="h4" component="h3">
          Search for scholarship
        </CoreTypography>

        <StyledNavigationButtonsWrap>
          <StyledNavigationLink to={`${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.allScholarships.hash}`}>
            Explore more
          </StyledNavigationLink>

          <div ref={navigationPrevRef}>
            {scholarships.length > 1 && (
              <ActionButton sx={sxStyles.paginationButton}>
                <ChevronLeftIcon />
              </ActionButton>
            )}
          </div>

          <div ref={navigationNextRef}>
            {scholarships.length > 1 && (
              <ActionButton sx={sxStyles.paginationButton}>
                <ChevronRightIcon />
              </ActionButton>
            )}
          </div>
        </StyledNavigationButtonsWrap>
      </StyledSliderHeader>

      <StyledSwiper
        spaceBetween={32}
        pagination={SWIPER_DATA.PAGINATION}
        navigation={{
          nextEl: navigationNextRef.current,
          prevEl: navigationPrevRef.current,
        }}
        modules={[Pagination, Navigation]}
        breakpoints={SWIPER_DATA.BREAKPOINTS}
        onBeforeInit={handleBeforeInit}
      >
        {scholarships.map((scholarship) => (
          <SwiperSlide key={scholarship.id}>
            <ScholarshipCard scholarship={scholarship} isViewOnly />
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </CoreBox>
  );
};
